module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAMAAAAOusbgAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABCUExURUxpcTMzMzMzM3t7ezMzM3p6ejMzMzMzMyoqKjMzM2JiYjIyMmpqajAwMGlpaTQ0NDU1NW5ubkFBQVhYWDMzMyoqKhHx28cAAAAUdFJOUwCfTqXvFFfpzfsq2kO9C4GrcmuXnjP/jQAAAMtJREFUaN7t2VsOgyAUhGFsVRDk4qX732pXwOmLE5v4fxuYnAiGyXEOAAAAwPXKpFHs2NiCSl6N3CmcOslIrqdS7gcnaXCausFNGhz6E8/S4MM4XXnRSdG6T/sgcuyRnyQAAACeIr5mjdV+Vlc/qvjW72xuXYTVadn6wcNdbXG8qx/XuyaOypFH4xu7OXmVVH/cY5GVegwAAIDHKE31ok/NWuM65RrX/+MaN2trarkpOPSDtWvcwThcefnIBKsvlu2tstFTAQAAgIt9AVCFiVot3IoiAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/home/liebiao1.png
// module id = /BHX
// module chunks = 12